import type { KeyboardEvent } from 'react';
import React, { useCallback } from 'react';

import { compose, composeU } from '../lib/compose';
import { isKeyCode, Keys } from '../lib/keyboard';
import { forceUtilityFocus } from '../lib/pointerFocus';
import { withSizeL } from './_size/Tumbler_size_l';
import { withSizeS } from './_size/Tumbler_size_s';
import { CHECKED_KEYS, Tumbler as TumblerCommon, UNCHECKED_KEYS } from './Tumbler';
import type { TumblerBaseProps } from './Tumbler.types';

const enhance = compose(composeU(withSizeS, withSizeL));

/**
 * @deprecated Use import { Switch } from '@yandex-int/hr-components/Switch'
 */
export const Tumbler = enhance(
    ({ checked, onKeyDown: htmlOnKeyDown, ...props }: TumblerBaseProps) => {
        const onKeyDown = useCallback(
            (event: KeyboardEvent<HTMLButtonElement>) => {
                if (
                    (!checked && isKeyCode(event, CHECKED_KEYS)) ||
                    (checked && isKeyCode(event, UNCHECKED_KEYS)) ||
                    isKeyCode(event, [Keys.SPACE])
                ) {
                    forceUtilityFocus();
                }

                if (htmlOnKeyDown !== undefined) {
                    htmlOnKeyDown(event);
                }
            },
            [checked, htmlOnKeyDown],
        );

        return <TumblerCommon checked={checked} onKeyDown={onKeyDown} {...props} />;
    },
);

Tumbler.displayName = TumblerCommon.displayName;

export type TumblerProps = React.ComponentProps<typeof Tumbler>;
